var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2 L4 6 L4 16 Q4 24 16 30 Q28 24 28 16 L28 6 Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4 L6 7 L6 16 Q6 23 16 28 Q26 23 26 16 L26 7 Z",
    fill: "#f4c420"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6 L8 8.5 L8 16 Q8 22 16 26 Q24 22 24 16 L24 8.5 Z",
    fill: "#1f8a3a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7 L9 9 L9 12 Q9 12 16 11 Q23 12 23 12 L23 9 Z",
    fill: "#3fb05c",
    opacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16 L14 19 L21 12 L19.5 10.5 L14 16 L12.5 14.5 Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4 L6 7 L6 8 L16 5 L26 8 L26 7 Z",
    fill: "#ffffff",
    opacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield32);
export default __webpack_public_path__ + "static/media/shield32.9080c0cc52735eb6f185273805d812e3.svg";
export { ForwardRef as ReactComponent };